import { Country, Station } from '@vueling-ng/vy-cdk-searcher';
import { AlertBanner } from 'app/shared/alerts/alert-banner/models/alert-banner.model';

export interface AppState {
  recordLocator: string | undefined;
  bookingStatus: string | undefined;
  stations: Station[] | undefined;
  countries: Country[] | undefined;
  user: UserInfo | undefined;
  language: string | undefined;
  imageLayout: string | undefined;
  currency: string | undefined;
  globalAlerts: AlertBanner[] | undefined;
}
export interface UserInfo {
  email: string;
  userName: string;
  userType: string;
}

export const ImageLayoutError = 'assets/images/background/foto_agencias_home.jpg';

export const emptyState = {
  recordLocator: undefined,
  bookingStatus: undefined,
  stations: undefined,
  countries: undefined,
  user: undefined,
  language: undefined,
  imageLayout: undefined,
  globalAlerts: undefined,
  currency: undefined
};
